import React, {useEffect, useState} from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import VideoImage from '../../../assets/img/video.webp';

import "./ProductSlider.sass"
import {futimes} from "fs";

const ProductSlider: React.FC<{
    openModalSlider: Function,
    images: string[],
    initialSlide: number,
    size: string,
    setInitialSlide: Function}> = ({
                                                            openModalSlider,
                                                            images,
                                                            initialSlide,
                                                            size,
                                                            setInitialSlide}) => {

    const [state, setState] = useState<{nav1: Slider | null, nav2: Slider | null}>({nav1: null, nav2: null})
    let slider1: Slider | null = null
    let slider2: Slider | null = null

    const getFileExtensionFromUrl = (url: string): string => {
        // Remove query parameters and hash fragments
        const urlWithoutParams = url.split('?')[0].split('#')[0];

        // Split by the dot and get the last part
        const parts = urlWithoutParams.split('.');

        // If there are multiple parts (indicating an extension), return the last one
        if (parts.length > 1) {
            return parts.pop() || ''; // Use pop() to get the last element and handle potential empty string
        }

        return ''; // No extension found
    }

    const getUrlWithoutExtension = (url: string): string => {
        const lastDotIndex = url.lastIndexOf('.');
        const lastSlashIndex = url.lastIndexOf('/');

        // If a dot exists and it's after the last slash (indicating an extension)
        if (lastDotIndex > -1 && lastDotIndex > lastSlashIndex) {
            return url.substring(0, lastDotIndex);
        }
        return url; // No extension found
    }

    useEffect(() => {
        setState({nav1: slider1, nav2: slider2})
    }, [])
        return (
            <div className="slider-main_wrapper">
                <Slider
                    className="slider-main"
                    asNavFor={state.nav2 ?? undefined }
                    ref={slider => (slider1 = slider)}
                    infinite={images.length <= 4 ?false : true}
                    initialSlide={initialSlide}
                    beforeChange={(currentSlide: number, nextSlide: number) => setInitialSlide(nextSlide)}
                >
                    {images.map((item, id) => {
                        let hasVideo = false
                        let videoId = ''
                        let url = item;
                        if (item.includes('youtube')) {
                            hasVideo = true

                            let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                            let match = item.match(regExp);


                            if(match&&match[7].length==11) {videoId = match[7]};


                        } else {
                            hasVideo = false;

                            if(size !== "Full" && item.toLowerCase().indexOf('ucenka_img') === -1) {
                                let ext = getFileExtensionFromUrl(item);
                                let file = getUrlWithoutExtension(item);
                                url = file + `_${size}.` + ext;
                            }
                        }

                        return (
                            <div key={id} onClick={() => openModalSlider()}>
                                {hasVideo ? <div className="video-wrapper">
                                    <iframe width="100" height="100"
                                                    src={"https://www.youtube.com/embed/" + videoId}
                                                    title="YouTube video player" frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                                                   allowFullScreen></iframe>
                                </div> : <img src={url} />}

                            </div>
                        )
                    })}

                </Slider>
                <div className="slider-thumb_wrapper">
                    <Slider
                        asNavFor={state.nav1 ?? undefined}
                        ref={slider => (slider2 = slider)}
                        slidesToShow={4}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        infinite={images.length <= 4 ?false : true}
                    >
                        {images.map((item, id) => {
                            let hasVideo = false
                            let url = item;
                            if (item.includes('youtube')) {hasVideo = true} else {
                                hasVideo = false;
                                if(item.toLowerCase().indexOf('ucenka_img') === -1)
                                {
                                    let file = getUrlWithoutExtension(item);
                                    let ext = getFileExtensionFromUrl(item);
                                    url = file + `_SinglePreview.` + ext;
                                }
                            }
                            return (
                                <div className="img-wrapper" key={id}>
                                    {hasVideo ? <img src={VideoImage} /> : <img src={url} />}
                                </div>
                            )
                        })}
                    </Slider>
                </div>

            </div>
        );
}
export default  ProductSlider;
